import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Flexbox from 'components/Flexbox';
import {DisplaySmall} from 'components/primitives/display';
import {Div} from 'components/primitives/body';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import network from './assets/network.svg';
import sync from './assets/sync.svg';


export class NetworkError extends React.Component {
    static propTypes = {
        error: PropTypes.any,
        refetch: PropTypes.func
    };

    componentDidMount() {
        this.logErrorMessage();
    }

    logErrorMessage = () => {
        const {error} = this.props;

        if (this.isQueryInFlightError(error)) {
            return;
        }

        const {graphQLErrors, networkError: _networkError} = error;

        if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
            graphQLErrors.forEach(({message, locations, path}) => {
                console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
            });
        }

        else if (_networkError) {
            console.error(`[Network error]: ${_networkError}`);
        }
        else {
            console.error(error);
        }
    };

    renderRefetch = () => {
        return (
            <RefetchWrapper onClick={() => this.props.refetch()}>
                <FormattedMessage {...messages.refetchData}/>
            </RefetchWrapper>
        );
    };

    renderReloadPage = () => {
        return (
            <div>
                <FormattedMessage {...messages.reloadPage}/>
            </div>
        );
    };

    isQueryInFlightError = (error) => {
        const queryInFlightErrorMessage = 'Store reset while query was in flight';

        return (error.message && error.message.includes(queryInFlightErrorMessage));
    };

    render() {
        if (this.isQueryInFlightError(this.props.error)) {
            return null;
        }

        return (
            <Wrapper>
                <NetworkImage/>
                <ContentWrapper>
                    <DisplaySmall>
                        <FormattedMessage {...messages.title}/>
                    </DisplaySmall>

                    <Div>
                        <FormattedMessage {...messages.description}/>
                    </Div>

                    {this.props.refetch ? this.renderRefetch() : this.renderReloadPage()}
                </ContentWrapper>
            </Wrapper>
        );
    }
}

const Wrapper = styled(Flexbox)`
  padding: 20px;
`;

const NetworkImage = styled.div`
  background: url(${network}) no-repeat 50% 50%;
  background-size: contain;
  flex-grow: 0;
  flex-shrink: 0;
  margin: 32px 60px;
  width: 120px;
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

const RefetchWrapper = styled(Div)`
  background: url(${sync}) no-repeat 4px 50%;
  display: inline-block;
  padding: 6px 12px 6px 40px;
  margin: 20px 0;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.08);
  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

export function networkError(error, refetch) {
    return <NetworkError error={error} refetch={refetch}/>;
}

export default NetworkError;
